// NPM Imports
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Button } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// CSS Imports
import signIn from "./signin.module.scss";

function SignInWrapper(props) {
  const {
    data: { domains, ociReSignUp, selectedDomain, showOrgInfo },
  } = props;

  const domain = domains.find(item => item.sub_domain === selectedDomain);

  // Local Function

  const _onGoBackClick = () => {
    if (ociReSignUp || (domains && domains.length === 1)) {
      props.toggleView({
        currentView: "verifyEmail",
        domains: [],
        email: "",
        isVerified: true,
        selectedDomain: "",
      });
    } else {
      props.toggleView({
        currentView: "orgListing",
        isVerified: true,
        selectedDomain: "",
      });
    }
  };

  return (
    <Fragment>
      {/** HEADER SECTION */}
      <section className={signIn.orgInfo}>
        {ociReSignUp ? (
          <Fragment>
            <div className={signIn.headerText}>
              You are already part of this org
            </div>
            <div className={signIn.fieldLabel}>
              Sign in to join your teammates to create documents that get things
              done!
            </div>
          </Fragment>
        ) : (
          <div className={signIn.headerText}>Log into Revv</div>
        )}

        {/** SELECTED SECTION */}
        {showOrgInfo && (
          <div className={signIn.selectedDomainWrapper}>
            <div
              className={signIn.selectedDomainBox}
              id={domain.sub_domain}
              onClick={() => _onGoBackClick()}
              onKeyPress={() => {}}
              role="button"
              tabIndex="0">
              <span className={signIn.domainInitial}>
                {domain.sub_domain.charAt(0)}
              </span>
              <span className={signIn.domainInfo}>
                <span className={signIn.domainName}>{domain.sub_domain}</span>
                <span className={signIn.domainMembersCount}>
                  {domain.user_count} members
                </span>
              </span>
              <span className={signIn.domainChange}>Change</span>
            </div>
          </div>
        )}
      </section>

      {/** BODY SECTION */}
      {React.cloneElement(props.children, {
        data: props.data,
        toggleView: props.toggleView,
      })}

      {/** FOOTER SECTION */}
      <section>
        <Button
          data-test="signin-go-back"
          className={signIn.goBackBtn}
          onClick={() => _onGoBackClick()}>
          <FontAwesomeIcon
            icon={["far", "arrow-left"]}
            className={signIn.goBackBtnIcon}
          />
          Go back
        </Button>
      </section>
    </Fragment>
  );
}

SignInWrapper.defaultProps = {};

SignInWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  data: PropTypes.shape({
    domains: PropTypes.arrayOf(
      PropTypes.shape({
        sub_domain: PropTypes.string.isRequired,
        user_count: PropTypes.number.isRequired,
      }),
    ),
    ociReSignUp: PropTypes.bool,
    selectedDomain: PropTypes.string,
    showOrgInfo: PropTypes.bool,
  }).isRequired,
  toggleView: PropTypes.func.isRequired,
};

export default SignInWrapper;
